import { createReducer } from "reduxsauce";
import importer from "common/importer";
const { INITIAL_STATE } = importer("Stores/Preview/InitialState", null);
const { PreviewTypes } = importer("Stores/Preview/Actions", null);

const getDrupalPreviewContentLoading = (state) => ({
  ...state,
  getDrupalPreviewContentLoading: true,
  getDrupalPreviewContentSuccess: null,
  getDrupalPreviewContentFailure: null,
});
const getDrupalPreviewContentSuccess = (state, { res }) => ({
  ...state,
  getDrupalPreviewContentLoading: false,
  getDrupalPreviewContentSuccess: res,
  getDrupalPreviewContentFailure: null,
});
const getDrupalPreviewContentFailure = (state, { error }) => ({
  ...state,
  getDrupalPreviewContentLoading: false,
  getDrupalPreviewContentSuccess: null,
  getDrupalPreviewContentFailure: error,
});

export const reducer = createReducer(INITIAL_STATE, {
  [PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT_LOADING]:
    getDrupalPreviewContentLoading,
  [PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT_SUCCESS]:
    getDrupalPreviewContentSuccess,
  [PreviewTypes.GET_DRUPAL_PREVIEW_CONTENT_FAILURE]:
    getDrupalPreviewContentFailure,
});
